import { render, staticRenderFns } from "./VehicleListTable.vue?vue&type=template&id=591c6675"
import script from "./VehicleListTable.vue?vue&type=script&lang=js"
export * from "./VehicleListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports